// Stato "la stampante è configurata come si aspetta ZStay?", calcolato lato client con una GET a ZBridge.
// Distinto da CashRegisterStatus (che riguarda solo la raggiungibilità del gateway/stampante lato backend):
// una cassa può essere Active come connessione e comunque avere una configurazione fiscale non allineata.
export enum CashRegisterFiscalConfigStatus {
  Valid,
  Invalid,
  Unreachable,
  // La stampante ha risposto, ma non espone i dati con cui confrontare: alcuni modelli dichiarano una  sezione come non applicabile, o la restituiscono vuota.
  // Non è un errore, ma nemmeno una conferma: quella cassa va verificata dal menù della stampante.
  NotVerifiable,
}
